"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CardHeader_1 = __importDefault(require("./CardHeader"));
exports.default = CardHeader_1.default;
